import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '#pplx/frontend/apps/ask/css/ask.css';
import '#pplx/frontend/apps/ask/css/fonts.css';
import '#pplx/frontend/components/global-ux/css/index.css';
import '#pplx/frontend/design/css/index.css';
import { listenForThreadPagesPreload } from '#pplx/frontend/apps/ask/page-components/thread-pages-preload/threadPagesPreloadEvent.js';
import { SupportsUnifiedComputerComposerContext } from '#pplx/frontend/apps/ask/providers/SupportsUnifiedComputerComposerContext.js';
import { SPA_ROUTES } from '#pplx/frontend/apps/ask/routing/spaRoutes.js';
import { ClientProviders } from '#pplx/frontend/apps/ask/runtime/providers/ClientComponentProviders.js';
import { preloadHomePage } from '#pplx/frontend/apps/ask/spa/HomePageRouteShared.js';
import { preloadThreadPage } from '#pplx/frontend/apps/ask/spa/pagePreloads.js';
import { getSpaQueryClientConfig } from '#pplx/frontend/apps/ask/spa/spaQueryClientConfig.js';
import { useApplyAnswerFontStyle } from '#pplx/frontend/apps/ask/user-settings/answerFontStyle.js';
import { ErrorBoundary } from '#pplx/frontend/platform-components/ErrorBoundary.js';
import { GlobalErrorFactory } from '#pplx/frontend/platform-components/GlobalError.js';
import RootProviders from '#pplx/frontend/platform-components/RootProviders.js';
import { LOCALE_TRANSLATIONS } from '#pplx_generated/pplx/frontend/apps/ask/spa/localeTranslations.generated.js';
import React from 'react';
const BASE = '/'; // no additional prefix base for home spa
const GlobalError = GlobalErrorFactory(BASE);
const userAgent = navigator.userAgent;
const host = window.location.host;
function ApplyAnswerFontStyle() {
    useApplyAnswerFontStyle();
    return null;
}
export function Shell({ bootstrapConfig, session, children, nativeBridgeStateCreator, }) {
    React.useEffect(() => {
        void preloadHomePage();
        return listenForThreadPagesPreload((target) => {
            void preloadThreadPage(target);
        });
    }, []);
    const { buildVersion, allowPersist } = getSpaQueryClientConfig(bootstrapConfig, userAgent);
    return (_jsx(ErrorBoundary, { fallback: GlobalError, children: _jsx(RootProviders, { host: window.location.hostname, userAgent: userAgent, session: session ?? undefined, serverEnvironment: bootstrapConfig.serverEnvironment, localeTranslations: LOCALE_TRANSLATIONS, queryClientBuildVersion: buildVersion, allowQueryClientPersist: allowPersist, children: _jsx(SupportsUnifiedComputerComposerContext, { value: true, children: _jsxs(ClientProviders, { hostname: host ?? '', buildTimestamp: bootstrapConfig.minVersion, buildVersion: buildVersion, spaRoutes: SPA_ROUTES, buildVersionRefresh: true, nativeBridgeStateCreator: nativeBridgeStateCreator, children: [_jsx(ApplyAnswerFontStyle, {}), children] }) }) }) }));
}
//# sourceMappingURL=shell.js.map